import { KEYSTORE_KEY } from "../constant"
import AES from "crypto-js/aes"
import EncUtf8 from "crypto-js/enc-utf8"

export interface Keystore {
  userId: string
  token: string
}

const host = window.location.host

export const saveKeystore = (keystore: Keystore) => {
  window.localStorage.setItem(KEYSTORE_KEY, AES.encrypt(JSON.stringify(keystore), host).toString())
}

export const getKeystore = () => {
  const value = window.localStorage.getItem(KEYSTORE_KEY)
  if (!value) return
  try {
    const keystore = JSON.parse(AES.decrypt(value, host).toString(EncUtf8)) as Keystore
    if (!keystore.userId || !keystore.token) throw new Error("Invalid keystore")

    return keystore
  } catch (e) {
    clearKeystore()
    return
  }
}

export const clearKeystore = () => {
  window.localStorage.removeItem(KEYSTORE_KEY)
}

export const checkKeystoreExist = () => {
  const keystore = getKeystore()
  return !!keystore
}
